import { parseResponseError } from "../Utils/errorUtils";
import axiosInstance from "../Utils/axiosInstance";
/**
 * Generic function opr for call get method in api by query params
 * @param {*} path
 * @param {*} params
 * @returns
 */
export const getCall = async (path, params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${path}?${searchParams.toString()}`
    );
    return response.data;
  } catch (error) {
    return parseResponseError(error);
  }
};
